import React, { useContext } from 'react';
import Playlist from '../Playlist';
import { X, Music, Play } from 'lucide-react';
import Context from '../../../../../Context/Context';

export const PlaylistSection = ({
  selectedPlaylist,
  handlePlaylistSelect,
  sidebarOpen,
  setSidebarOpen
}) => {
  const Ctx = useContext(Context);
  const isDarkMode = Ctx.isDarkMode ?? true;

  return (
    <div className={`h-full flex flex-col transition-colors duration-200 ${isDarkMode ? 'bg-[#1a1a1a]' : 'bg-white'}`} style={{ fontFamily: "Inter, sans-serif" }}>
      {/* Header */}
      <div className={`flex items-center justify-between p-3 md:p-4 border-b ${isDarkMode ? 'border-[#2a2a2a]' : 'border-gray-200'}`}>
        <div className="flex items-center space-x-2">
          <Music className={`w-4 h-4 md:w-5 md:h-5 ${isDarkMode ? 'text-[#FDCF08]' : 'text-[#FDCF08]'}`} />
          <h2 className={`text-base md:text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Playlists</h2>
        </div>
        <button
          onClick={() => setSidebarOpen(false)}
          className={`md:hidden p-2 rounded-lg transition-colors ${
            isDarkMode ? 'hover:bg-[#2a2a2a] text-white' : 'hover:bg-gray-100 text-gray-700'
          }`}
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Playlist Content */}
      <div className="flex-1 overflow-y-auto scrollbar-hide">
        <Playlist
          onSelectPlaylist={handlePlaylistSelect}
          selectedPlaylist={selectedPlaylist}
        />
      </div>

      {/* Footer */}
      <div className={`p-3 md:p-4 border-t ${isDarkMode ? 'border-[#2a2a2a] bg-[#0f0f0f]' : 'border-gray-200 bg-gray-50'}`}>
        <div className="text-center">
          <Play className={`w-4 h-4 mx-auto mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`} />
          <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            Select a playlist to view videos
          </p>
        </div>
      </div>
    </div>
  );
};